import Typical from 'react-typical';
import Contact from '../anexo/contact';

import AlfeuX from '../img/AlfeuX.jpg';

export default function Profile(){
    return(
        <section className='profile'>
          <div className='me'>
            <div>
              <h2>
                <Typical
                  loop={Infinity}
                  steps={
                    [
                      "Web Dev.", 3000,
                      "UX/UI Design enthusiast", 3000,
                      "Freelancer", 3000,
                    ]
                  }
                />
              </h2>
              <h1> Alfeu Xerinda </h1>
              <h4> {"(Hard.0_0.7)"} </h4>
            </div>
            <div>
              <p>
                <i>Get in touch with me to build your: </i>
                <h3>
                  <Typical
                    loop={Infinity}
                    steps={
                      [
                        "Website", 2000,
                        "Portfolio", 2000,
                        "WebApp", 2000,
                        "Landig Pages", 2000
                      ]
                    }
                  />
                </h3> 
              </p>
            </div>
            <Contact/>
          </div>
          <div className='me-selfie'>
            <img src={AlfeuX} alt='Alfeu`s selfie' />
          </div>
        </section>
    );
}